import React, { useEffect, useState } from 'react'
import { styled } from "@mui/material/styles";
import '../../superadmin/styles/pages/dashboard.css';
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, TextField, InputLabel, FormControl, Select, MenuItem, Button, FormHelperText } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import instance from '../../utils/Api';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useGlobalContext } from '../../Contex'; // Adjust the path
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import Grid from "@mui/material/Grid2";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const AddTeacher = ({ classesDetail, setAddstudents, onProductUpdate, openDialog, setOpenDialog, schoolId, sectionId, selectedProduct }) => {
    const [rollno, setRollno] = useState();
    const [name, setName] = useState();
    const [email, setEmail] = useState();
    const [mobileno, setMobileno] = useState();
    const [gender, setGender] = useState();
    const [agelimit, setAgelimit] = useState();
    const [fathername, setFathername] = useState();
    const [mothername, setMothername] = useState();
    const [age, setAge] = useState();
    const [birthdate, setBirthdate] = useState(null);
    const [siblings, setSiblings] = useState();
    const [profilepic, setProfilepic] = useState();
    const [nameError, setNameError] = useState('');
    const [rollError, setRollError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [mobilenoError, setMobilenoError] = useState('');
    const [genderError, setGenderError] = useState('');
    const [agelimitError, setAgelimitError] = useState('');
    const [fathernameError, setFathernameError] = useState('');
    const [mothernameError, setMothernameError] = useState('');
    const [ageError, setAgeError] = useState('');
    const [birthdateError, setBirthdateError] = useState('');
    const { buttondisable, setButtondisable } = useGlobalContext();
    const [studentId, setStudentId] = useState();

    //function popup close
    const handleClose = () => {
        setOpenDialog(false);
        //empty usestates
        setName('');
        setEmail('');
        setRollno('');
        setMobileno('');
        setGender('');
        setAgelimit('');
        setFathername('');
        setMothername('');
        setAge('');
        setBirthdate(null)

        //empty validationerror
        setNameError('');
        setEmailError('');
        setMobilenoError('');
        setNameError('');
        setGenderError('');
        setAgelimitError('');
        setFathernameError('');
        setMothernameError('');
        setAgeError('');
        setBirthdateError('')
    };

    const validationform = () => {
        let isValid = true;

        // Name validation
        if (!name) {
            setNameError('Full Name is required');
            isValid = false;
        } else {
            setNameError('');
        }



        // Mobile number validation
        const mobileRegex = /^[6-9]\d{9}$/; // Regex to match only numbers
        if (!mobileno) {
            setMobilenoError('Mobile number is required');
            isValid = false;
        } else if (!mobileRegex.test(mobileno.toString().trim())) {
            setMobilenoError('Enter a valid 10-digit mobile number');
            isValid = false;
        } else {
            setMobilenoError("")
        }

        // Gender validation
        if (!gender) {
            setGenderError("Please select a gender");
            isValid = false;
        } else {
            setGenderError("");
        }


        return isValid;
    }

    useEffect(() => {
        if (openDialog && selectedProduct) {
            setRollno(selectedProduct?.rollno || "");
            setName(selectedProduct?.name || "")
            setFathername(selectedProduct?.fatherName || "")
            setMobileno(selectedProduct?.whatsappNumber || "")
            setGender(selectedProduct?.gender || "")
            setStudentId(selectedProduct?._id || "")
        }
    }, [openDialog, selectedProduct]);



    //add sctudents api call
    const handleAddStudents = async () => {
        if (!validationform()) {
            return;
        }
        setButtondisable(true);
        try {
            const response = await instance.post('/api/v1/newrouts/addTeacher', {
                name: name,
                whatsappNumber: mobileno,
                gender: gender,
            });
            if (response.data.success === true) {
                onProductUpdate();
                toast.success(response.data.message)
                handleClose();
                setAddstudents(true);// Trigger refresh after create schools
                setButtondisable(false);
            } else {
                toast.error(response.data.message);
                setButtondisable(false);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
            console.log(error.response);
            setButtondisable(false);
        }
    }

    const handleUpdateStudents = async () => {
        if (!validationform()) {
            return;
        }
        setButtondisable(true);
        try {
            const response = await instance.put(`/api/v1/newrouts/updateTeacher/${studentId}`, {
                name: name,
                whatsappNumber: mobileno,
                gender: gender,
            });
            if (response.data.success === true) {
                onProductUpdate();
                toast.success(response.data.message)
                handleClose();
                // setAddstudents(true);// Trigger refresh after create schools
                setButtondisable(false);
                
            } else {
                toast.error(response.data.message);
                setButtondisable(false);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
            console.log(error.response);
            setButtondisable(false);
        }
    }
    console.log(gender);
    


    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={openDialog}
                className="admin-admins"
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    {selectedProduct ? "Update Teacher" : "Add Teacher"}
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <section>
                        <div className='add-admin'>
                            <Grid container spacing={2}>
                                
                                <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
                                    <div className='admin-textfiled'>
                                        <TextField
                                            placeholder='Enter Teacher Name'
                                            label='Teacher Name'
                                            type='text'
                                            fullWidth
                                            required
                                            value={name}
                                            onChange={(e) => { setName(e.target.value); setNameError('') }}
                                            error={Boolean(nameError)}
                                        />
                                        <FormHelperText error={Boolean(nameError)}>
                                            {nameError}
                                        </FormHelperText>
                                    </div>
                                </Grid>
                                <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
                                    <div className='admin-textfiled'>
                                        <FormControl fullWidth error={Boolean(genderError)} required>
                                            <InputLabel id="demo-simple-select-label">Gender</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={gender}
                                                label="Gender"
                                                onChange={(e) => { setGender(e.target.value); setGenderError('') }}
                                            >
                                                <MenuItem value="Male">Male</MenuItem>
                                                <MenuItem value="Female">Female</MenuItem>
                                            </Select>
                                        </FormControl>
                                        <FormHelperText error={Boolean(genderError)}>
                                            {genderError}
                                        </FormHelperText>
                                    </div>
                                </Grid>
                                <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
                                    <div className='admin-textfiled'>
                                        <TextField
                                            placeholder='Enter Whatsapp number'
                                            label='Whatsapp Number'
                                            type='number'
                                            fullWidth
                                            required
                                            value={mobileno}
                                            onChange={(e) => { setMobileno(e.target.value); setMobilenoError('') }}
                                            error={Boolean(mobilenoError)}
                                            onInput={(e) => { e.target.value = Math.max(0, parseInt(e.target.value).toString().slice(0, 10)) }}
                                        />
                                        <FormHelperText error={Boolean(mobilenoError)}>
                                            {mobilenoError}
                                        </FormHelperText>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </section>
                </DialogContent>
                <DialogActions>
                    <Button
                        className="cancel-btn"
                        onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        className="add-btn"
                        onClick={selectedProduct ? handleUpdateStudents : handleAddStudents}
                        disabled={buttondisable}
                    >
                        {selectedProduct ? "Update" : "Add"}
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    )
}

export default AddTeacher;

